import { useState } from 'react';

// Icons
import { IoMdClose } from 'react-icons/io';
import { CgMenuRight } from 'react-icons/cg';
import { FaFacebookF, FaInstagram, FaTiktok, FaWhatsapp, FaYoutube, FaStar } from 'react-icons/fa6';
import { SiGooglemybusiness } from 'react-icons/si';

// Router
import { Link } from 'react-router-dom';

// Motion
import { motion } from 'framer-motion';

const menuVariants = {
  hidden: { x: '100%' },
  show: {
    x: 0,
    transition: { ease: [0.6, 0.01, -0.05, 0.9] },
  },
};

// نفس روابط Footer
const socialLinks = {
  facebook: 'https://www.facebook.com/youkagmbh',
  instagram: 'https://www.instagram.com/youkagmbh',
  tiktok: 'https://www.tiktok.com/@youkagmbh',
  whatsapp: 'https://wa.me/491604035965',
  youtube: 'https://www.youtube.com/@youkagmbh',
  googleBusiness: 'https://share.google/mOe0aR4AdyHDlkLxr',
  googleReview: 'https://search.google.com/local/writereview?placeid=ChIJscuryPlYPAwRUrn4oiEFTMw',
};

const MobileNav = () => {
  const [openMenu, setOpenMenu] = useState(false);
  const closeMenu = () => setOpenMenu(false);

  return (
    <nav>
      {/* زر فتح القائمة */}
      <div onClick={() => setOpenMenu(true)} className="text-1xl mt-1 cursor-pointer text-[#103d5b]">
        <CgMenuRight />
      </div>

      {/* القائمة الجانبية */}
      <motion.div
        variants={menuVariants}
        initial="hidden"
        animate={openMenu ? 'show' : ''}
        className="bg-white shadow-2xl w-full absolute top-0 right-0 max-w-xs h-screen z-20"
      >
        {/* زر الإغلاق */}
        <div
          onClick={() => setOpenMenu(false)}
          className="text-2xl absolute z-30 left-6 top-12 text-[#103d5b] cursor-pointer"
        >
          <IoMdClose />
        </div>

        {/* محتوى القائمة */}
        <div className="h-full flex flex-col items-center justify-center gap-y-8 px-6">

          {/* قائمة الروابط */}
          <ul className="flex flex-col items-start gap-y-5 text-[#103d5b] font-primary font-bold text-base">
            <li><Link to="/" onClick={closeMenu}>Home</Link></li>
            <li><Link to="/UnsereMission" onClick={closeMenu}>Unsere Mission</Link></li>
            <li><Link to="/Projekte" onClick={closeMenu}>Projekte</Link></li>
            <li><Link to="/Kontakt" onClick={closeMenu}>Kontakt</Link></li>
            <li><Link to="/Impressum" onClick={closeMenu}>Impressum</Link></li>
            <li><Link to="/Datenschutz" onClick={closeMenu}>Datenschutz</Link></li>
          </ul>

          <div className="flex items-center justify-center gap-5 text-[#103d5b] mt-4">
            <a href={socialLinks.facebook} aria-label="Facebook" target="_blank" rel="noopener noreferrer" onClick={closeMenu}>
              <FaFacebookF className="text-xl hover:opacity-80" />
            </a>
            <a href={socialLinks.instagram} aria-label="Instagram" target="_blank" rel="noopener noreferrer" onClick={closeMenu}>
              <FaInstagram className="text-xl hover:opacity-80" />
            </a>
            <a href={socialLinks.tiktok} aria-label="TikTok" target="_blank" rel="noopener noreferrer" onClick={closeMenu}>
              <FaTiktok className="text-xl hover:opacity-80" />
            </a>
            <a href={socialLinks.whatsapp} aria-label="WhatsApp" target="_blank" rel="noopener noreferrer" onClick={closeMenu}>
              <FaWhatsapp className="text-xl hover:opacity-80" />
            </a>
            <a href={socialLinks.youtube} aria-label="YouTube" target="_blank" rel="noopener noreferrer" onClick={closeMenu}>
              <FaYoutube className="text-2xl hover:opacity-80" />
            </a>
            {/* ✅ أيقونة Google Business الجديدة */}
            <a href={socialLinks.googleBusiness} aria-label="Google Business" target="_blank" rel="noopener noreferrer" onClick={closeMenu}>
              <SiGooglemybusiness className="text-xl text-blue-500 hover:opacity-80" />
            </a>
            <a
              href={socialLinks.googleReview}
              aria-label="Bewerten Sie uns auf Google"
              target="_blank"
              rel="noopener noreferrer"
              title="Bewerten Sie uns auf Google ⭐"
              onClick={closeMenu}
            >
              <FaStar className="text-xl text-yellow-400 hover:text-yellow-500" />
            </a>
          </div>
        </div>
      </motion.div>
    </nav>
  );
};

export default MobileNav;
